import { Link } from 'react-router-dom';
import { LOGO_BASE_URL } from '../../apiConfig';
import teamLogo from '../../images/team-logo.png';
import { motion } from 'framer-motion';

function TeamCard({ data, league }) {
    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const isMobile = window.innerWidth <= 768;
    const accentYellow = '#E7C424';

    const styles = {
        card: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: isMobile ? '16px' : '28px',
            gap: isMobile ? '16px' : '20px',
            width: '100%',
            minHeight: isMobile ? '180px' : '260px',
            background: 'linear-gradient(180deg, #0812BB 0%, #000443 100%)',
            textDecoration: 'none',
            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
            cursor: 'pointer',
            boxSizing: 'border-box',
            borderRadius: '0px',
            border: '1px solid rgba(255,255,255,0.05)',
            position: 'relative',
            overflow: 'hidden',
        },
        logoWrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: isMobile ? '90px' : '110px',
            height: isMobile ? '90px' : '110px',
            borderRadius: '12px',
            background: '#FFFFFF',
            overflow: 'hidden',
            boxSizing: 'border-box',
            padding: '12px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
        },
        infoBox: {
            display: 'flex', 
            flexDirection: 'column', 
            gap: '4px', 
            alignItems: 'center',
            width: '100%',
        },
        clubName: {
            fontFamily: 'var(--fontAnton)',
            fontWeight: 400,
            fontSize: isMobile ? '16px' : '18px',
            color: '#FFFFFF',
            margin: '0 0 2px 0',
            textAlign: 'center',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            lineHeight: 1.2,
        },
        teamName: {
            fontFamily: 'var(--fontInter)',
            fontWeight: 500,
            fontSize: isMobile ? '12px' : '13px',
            color: 'rgba(255,255,255,0.6)',
            margin: 0,
            textAlign: 'center',
            textTransform: 'uppercase',
            letterSpacing: '0.8px',
        }
    };

    return (
        <motion.div
            whileHover={{ 
                y: -8,
                backgroundColor: 'rgba(255,255,255,0.02)'
            }}
            style={{ width: '100%' }}
        >
            <Link 
                style={styles.card} 
                to={"/team-profile/" + data.club_id + "/" + data.team_id}
                onClick={handleScrollToTop}
            >
                <div style={styles.logoWrapper}>
                    <img 
                        src={data.team_logo ? `${LOGO_BASE_URL}/${data.team_logo}` : teamLogo} 
                        alt={data.club_name} 
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        }} 
                    />
                </div>
                
                <div style={styles.infoBox}>
                    <p style={styles.clubName}>{data.club_name}</p>
                    <p style={styles.teamName}>{data.team_name}</p>
                </div>
            </Link>
        </motion.div>
    );
}

export default TeamCard;